/* eslint-disable */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import is from 'is_js'
import FlexBox from '../common/FlexBox'
import Select from '../common/Select'
import CalendarInput from '../exchange/CalendarInput'
import { FilterButton } from '../../containers/order/openOrders'
import zIndex from '../../utils/zIndexScale'
import SearchSymbol from './SearchSymbol'
import { withI18n } from '../../i18n/util'

const TabContainer = styled(FlexBox)`
  height: 30px;
  padding-left: 0.5em;
  background: ${({ theme }) => theme.filterbg};
  flex: none;
  color: #212833;
  position: relative;
`

export const Tab = styled.div`
  color: ${({ selected }) => (selected ? '#F0B90B' : '#848E9C')};
  cursor: pointer;
  margin: ${({ margin }) => margin || '0 2px'};
  outline: 0;
  height: 22px;
  line-height: 22px;
  font-size: 12px;
  background: #212833;
  padding: 0 5px;
  border-radius: 3px;
  &:hover {
    color: #f0b90b;
  }
`

const DateFilter = styled(FlexBox)`
  height: 30px;
  position: relative;
  z-index: ${zIndex.filter};
  .react-calendar {
    background: #fff;
  }
  input {
    background: #fff;
    border: none;
    border-bottom: 1px solid #dfe2e7;
  }
  .calendarOuter {
    bottom: auto;
    top: 30px;
  }
`

const TypeFilter = styled(FlexBox)`
  align-items: center;
  margin-left: 10px;
  span {
    margin-right: 5px;
  }
`

const Buy = styled.span`
  color: #00c087;
`

const Sell = styled.span`
  color: ${({ theme }) => theme.down};
`

const Hyphen = styled.span`
  color: #848e9c;
`

class OrderHistoryFilter extends React.Component {
  static propTypes = {
    onFilterChange: PropTypes.func,
    reset: PropTypes.func,
    symbol: PropTypes.string,
    hasType: PropTypes.bool,
    hasPair: PropTypes.bool,
    defaultDate: PropTypes.date,
    formatI18nText: PropTypes.func,
  }

  static defaultProps = {
    onFilterChange: () => {},
    reset: () => {},
    symbol: '',
    hasType: true,
    hasPair: true,
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    const currentDate = new Date()
    const date = props.defaultDate
      ? new Date(props.defaultDate)
      : currentDate.setDate(currentDate.getDate() - 7)
    this.state = {
      manualStartDate: new Date(date),
      manualEndDate: new Date(),
      period: '',
      type: ['Buy', 'Sell'],
      baseAsset: '',
      quoteAsset: '',
      side: '',
    }
  }

  componentDidUpdate({ symbol }) {
    if (symbol !== this.props.symbol) {
      this._resetManualDates()
    }
  }

  _setTab = (ev, period) => {
    if (ev && ev.target && period === this.props.period) return
    const { onFilterChange } = this.props
    const date = new Date()
    const end = date.setHours(24, 0, 0, 0)
    let start
    switch (period) {
      case '3m':
        start = date.setMonth(date.getMonth() - 3)
        break
      case '1m':
        start = date.setMonth(date.getMonth() - 1)
        break
      case '1w':
        start = date.setDate(date.getDate() - 7)
        break
      case '1d':
      default:
        start = date.setDate(date.getDate() - 1)
        break
    }
    if (period !== '1d') start = date.setDate(date.getDate() - 1)
    this.setState({ period }, () => {
      onFilterChange && onFilterChange({ start, end })
    })
  }

  _search = () => {
    const { manualStartDate, manualEndDate, side, baseAsset, quoteAsset } = this.state
    const { onFilterChange } = this.props
    if (!is.existy(manualStartDate)) return
    const params = {}
    if (is.date(manualStartDate)) {
      params.manualStartDate = manualStartDate
    }
    if (is.date(manualEndDate)) {
      params.manualEndDate = manualEndDate
    }
    if (side && side !== 'Buy&Sell') params.side = side === 'Buy' ? 1 : 2
    if (baseAsset) params.baseAsset = baseAsset
    if (quoteAsset) params.quoteAsset = quoteAsset

    onFilterChange && onFilterChange(params)
  }

  _reset = () => {
    const { reset } = this.props
    this.setState(
      {
        manualStartDate: '',
        manualEndDate: '',
        period: '',
        type: ['Buy', 'Sell'],
        baseAsset: '',
        quoteAsset: '',
        side: '',
      },
      () => {
        reset && reset()
      }
    )
  }

  _buildType = () => {
    const { type } = this.state
    const { formatI18nText } = this.props
    const result = []
    type.forEach(item => {
      if (item === 'Buy') {
        result.push(<Buy>{formatI18nText('exchange.buy')}</Buy>)
      }
      if (item === 'Sell') {
        result.push(<Sell>{formatI18nText('exchange.sell')}</Sell>)
      }
    })
    return result.length > 1 ? result.join(' & ') : result.join('')
  }

  _typeChange = side => {
    this.setState({ side })
  }

  _resetManualDates() {
    this.setState({ manualStartDate: '', manualEndDate: '' })
  }

  _symbolChange = (baseAsset, quoteAsset) => {
    this.setState({ baseAsset, quoteAsset })
  }

  render() {
    const { symbol, hasType, hasPair, formatI18nText } = this.props
    const typeOptions = [
      {
        value: 'Buy&Sell',
        text: 'Buy & Sell',
        render: () => (
          <React.Fragment>
            <Buy>{formatI18nText('exchange.buy')}</Buy>
            {' & '}
            <Sell>{formatI18nText('exchange.sell')}</Sell>
          </React.Fragment>
        ),
      },
      {
        value: 'Buy',
        text: 'Buy',
        render: () => (
          <React.Fragment>
            <Buy>{formatI18nText('exchange.buy')}</Buy>
          </React.Fragment>
        ),
      },
      {
        value: 'Sell',
        text: 'Sell',
        render: () => (
          <React.Fragment>
            <Sell>{formatI18nText('exchange.sell')}</Sell>
          </React.Fragment>
        ),
      },
    ]

    const { manualStartDate, manualEndDate } = this.state

    return (
      <TabContainer flex="1 0 100%" align="center" justify="space-between">
        <FlexBox>
          <DateFilter align="center">
            {formatI18nText('exchange.time.from')}:&nbsp;
            <CalendarInput
              symbol={symbol}
              defaultValue={manualStartDate}
              maxDateStr={manualEndDate}
              callbackFn={manualStartDate => this.setState({ manualStartDate })}
            />
            <Hyphen>-</Hyphen>
            &nbsp;
            <CalendarInput
              symbol={symbol}
              minDateStr={manualStartDate}
              defaultValue={manualEndDate}
              callbackFn={manualEndDate => this.setState({ manualEndDate })}
            />
          </DateFilter>
          {hasType && (
            <TypeFilter>
              <span>{formatI18nText('exchange.side')}:</span>
              <Select options={typeOptions} width="100px" onChange={this._typeChange} />
            </TypeFilter>
          )}
          {hasPair && <SearchSymbol onChange={this._symbolChange} />}
          <FlexBox style={{ marginLeft: '10px' }}>
            <FilterButton onClick={this._search}>
              <span>{formatI18nText('exchange.search')}</span>
            </FilterButton>
          </FlexBox>
        </FlexBox>
      </TabContainer>
    )
  }
}

export default withI18n(OrderHistoryFilter)
